import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserLogged } from '@models';
import { AuthService } from '@services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ggi-journey-client-header',
  templateUrl: './client-header.component.html',
  styleUrls: ['./client-header.component.scss'],
})
export class ClientHeaderComponent implements OnInit, OnDestroy {
  public menu = false;
  public user: UserLogged;

  public authSubscription = Subscription.EMPTY;

  constructor(
    private readonly router: Router,
    private readonly auth: AuthService
  ) {}

  ngOnInit(): void {
    this.getClientFromStorage();
    this.getClientStatus();
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  public getClientStatus(): void {
    this.authSubscription = this.auth.userStatus.subscribe(() => {
      this.getClientFromStorage();
    });
  }

  public getClientFromStorage(): void {
    const user = this.auth.getUser();
    if (user) {
      this.user = user;
    }
  }

  public goTo(url: string): void {
    this.menu = false;
    this.router.navigateByUrl(url);
  }

  public logout(): void {
    this.authSubscription = this.auth.logout().subscribe(() => {
      this.auth.removeUser();
      this.router.navigateByUrl('/iniciar-sesion');
    });
  }
}
